import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import type React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getDynamicsMappingFieldsThunk } from "../store/effects/dynamicsApi";
import { getHsMappingFieldsThunk } from "../store/effects/hubspotApi";
import { getSfMappingFieldsThunk } from "../store/effects/salesforceApi";
import { ExportIntegrations } from "app/pages/sales-intelligence/pages/management/types/types";

const withMappingFieldsCall = <P,>(Component: React.ComponentType<P>) => {
    return function WrappedWithMappingFieldsCall(props: P) {
        const dispatch = useDispatch();

        const { integrationName } = getIntegrationNameFromUrl();

        useEffect(() => {
            if (integrationName === ExportIntegrations.salesforce) {
                dispatch(getSfMappingFieldsThunk());
            }

            if (integrationName === ExportIntegrations.hubspot) {
                dispatch(getHsMappingFieldsThunk());
            }

            if (integrationName === ExportIntegrations.dynamics) {
                dispatch(getDynamicsMappingFieldsThunk());
            }
        }, []);

        return <Component {...props} />;
    };
};

export default withMappingFieldsCall;
